export const SUBSCRIPTION_MANAGEMENT_ROUTE = '/subscription-management'
export const CANCEL_SUBSCRIPTION_ROUTE = '/subscription-management/cancel'
export const EXPLORE_PLANS_ROUTE = '/subscription-management/explore-plans'

export const SUBSCRIPTION_MANAGEMENT_ROUTES = [
    SUBSCRIPTION_MANAGEMENT_ROUTE,
    CANCEL_SUBSCRIPTION_ROUTE,
    EXPLORE_PLANS_ROUTE,
] as const
